import { Link, Outlet } from "react-router-dom";

function Guest() {
    return (
        <Outlet />
    )
}

export default Guest;